import { render, staticRenderFns } from "./leftNews.vue?vue&type=template&id=63a8b448&scoped=true"
import script from "./leftNews.vue?vue&type=script&lang=js"
export * from "./leftNews.vue?vue&type=script&lang=js"
import style0 from "./leftNews.vue?vue&type=style&index=0&id=63a8b448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8b448",
  null
  
)

export default component.exports